import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
import Loading from "../../../../Extra/Loading";
import NonWorkingController from "./NonWorkingController";
import NonWorkingTable from "./NonWorkingTable";
const sampleState = {
  MACHINE_DATE: false,
  SECTION_NAME: false,
  MACHINE_NAME: false,
  ASSET: false,
  CAUSE: false,
};
const NonWorkingMaster = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [dateRange, setDateRange] = useState([]);
  const [filterData, setFilteredData] = useState(null);
  const [dataForTable, setDataForTable] = useState(null);
  const [openStates, setOpenStates] = useState(sampleState);
  const [machineData, setMachineData] = useState(null);

  const getDateRange = () => {
    const dates = [];
    let currentDate = new Date(startDate);
    const stopDate = new Date(endDate);

    while (currentDate <= stopDate) {
      dates.push(currentDate.toISOString().slice(0, 10));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const fetchNonWorkingData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlBlockPrefix}getNonWorkingData?start=${startDate}&end=${endDate}`
      );
      const range = getDateRange();
      //   setGlobalDateRange(range);
      if (response.data.status === "ok") {
        const fetchedData = response.data.daterange.data;
        const finalData = fetchedData.filter((o) => o.CAUSE !== "WORKING");

        setData(finalData);
      }
      setLoading(false);
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setLoading(false);

      setError(true);
    }
  };
  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlBlockPrefix}getmachinetype`);
      if (response.data.status === "ok") {
        const raw = response.data.machineTypes;
        const filtered = raw.filter((o) => o.DEPARTMENT === "ENGINEERING");
        const flattened = filtered.flatMap((o) =>
          o.children.flatMap((o) => o.children)
        );

        setMachineData(flattened);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineData();

    fetchNonWorkingData();
  }, []);
  const getDatesInRange = (start, end) => {
    const date = new Date(start);
    const dates = [];
    while (date <= new Date(end)) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  };

  useEffect(() => {
    const dates = getDatesInRange(startDate, endDate);
    setDateRange(dates);
  }, [data]);
  return (
    <div
      onClick={() => {
        setOpenStates(sampleState);
      }}
    >
      {" "}
      {loading && <Loading />}
      <div className="d-flex justify-content-between bg-dark p-1 text-white">
        <h5 className="ms-1"> Insert Date </h5>
        <div>
          <b>From </b>
          <input
            type="date"
            value={startDate}
            max={endDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="me-1"
          />
          <b>To </b>
          <input
            type="date"
            value={endDate}
            max={getCurrentDate()}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <button
            className="ms-1 btn btn-sm btn-outline-light"
            onClick={fetchNonWorkingData}
          >
            Fetch
          </button>
        </div>
      </div>
      <div
        className="sticky-controller"
        style={{ zIndex: 3 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {data && machineData && (
          <NonWorkingController
            data={data}
            machineData={machineData}
            setFilteredData={setFilteredData}
            setOpenStates={setOpenStates}
            openStates={openStates}
            setDataForTable={setDataForTable}
          />
        )}
      </div>
      <NonWorkingTable data={filterData} />
    </div>
  );
};
export default NonWorkingMaster;
